import SuperFetch from 'library/helpers/superFetch';
import { useEffect, useState } from 'react';
import {
	InventoryControlGatewaysTable,
	InventoryControlLocksTable,
	InventoryGatewaysTable,
	InventoryLocksTable,
	InventoryOrganisationTable
} from 'zComponents/molecules';
import { Tabs } from 'zui/Antd';
const { TabPane } = Tabs;

const InventoryTabs = () => {
	// local state
	const [workspaces, setWorkspaces] = useState([]);

	useEffect(() => {
		SuperFetch.get('/organisations/AllOrgs')
			.then((res) => {
				if (res.statusCode === 200) {
					setWorkspaces(res.data);
				} else {
					Notification('error', 'Error fetching workspace data. Please try again');
				}
			})
			.catch((e) => e);
	}, []);

	return (
		<Tabs size='small' defaultActiveKey='1' type='card' animated={{ inkBar: true, tabPane: true }}>
			<TabPane tab='Locks' key='1'>
				<InventoryLocksTable workspaces={workspaces} />
			</TabPane>
			<TabPane tab='Gateways' key='2'>
				<InventoryGatewaysTable workspaces={workspaces} />
			</TabPane>
			<TabPane tab='Control Locks' key='3'>
				<InventoryControlLocksTable workspaces={workspaces} />
			</TabPane>
			<TabPane tab='Control Gateways' key='4'>
				<InventoryControlGatewaysTable workspaces={workspaces} />
			</TabPane>
			<TabPane tab='Organisation' key='5'>
				<InventoryOrganisationTable workspaces={workspaces} />
			</TabPane>
		</Tabs>
	);
};

export default InventoryTabs;
